import React, { useEffect } from "react";
import {usePageViewTracking} from "../features/analytics/Analytics";

const ErrorContent = ({ t }) => {
  const trackView = usePageViewTracking();
    useEffect(() => {
      document.title = "Error | Leave a Review";
      trackView(document.title);
  }, [trackView]);

  return (
    <main>
      <p>{t("error")}</p>
    </main>
  );
};

export default ErrorContent;
